var wsod_Warrants = {};

(function($) {

	var typeWidth = 201;
	var dateWidth = 136;

	wsod_Warrants.issueType = "";
	wsod_Warrants.filters = [];
	wsod_Warrants.PageOptions = {
		"RowCount": 20
	, "FirstRow": 1
	};

	wsod_Warrants.update = function(data, status, xhr) {

		var tbody = $('#WSOD_OptionData').find('tbody');
		wsod.hideAjaxLoader(tbody);

		if (data.html) {
			$('#WSOD_OptionData').parent().html(data.html);
		}

		if (data.expirations) {

			$('#wsod_selOptionDate').parent().remove();
			$('#WSOD_OptionNav').append(data.expirations);
			var select = $('#wsod_selOptionDate').selectmenu({ style: 'dropdown', change: wsod_Warrants.filter, root: wsod.getRoot()});


			//-- mac firefox (selectmenu width not being applied) --//
			$('div.wsod ul.wsod_selOptionDate').width(dateWidth);
			$('#WSOD_OptionNav .wsod_selOptionDate').next().width(dateWidth);
			//-- mac firefox --//

			wsod_Warrants.filters[1] = select;
		}

		if (data.pagerOptions) {
			var pagerJSON = $.fromJSON(data.pagerOptions);			// TT0229627
			$('#WSOD_OptionData .paging').pagination(pagerJSON);
			wsod_Warrants.data = $('#WSOD_OptionData').find('tbody tr');
			
			//need to reset PageOptions.FirstRow because wsod_Options.PageRequest() uses FirstRow for pagination
			wsod_Warrants.PageOptions.FirstRow = pagerJSON && pagerJSON.StartIndex;

			for (var i = 20; i < wsod_Warrants.data.length; i++) {
				wsod.hide($(wsod_Warrants.data[i]));
			}
		}

		// update header
		var headerFields = [];
		$('#WSOD_OptionNav .ui-selectmenu-status').each(function() {
			headerFields.push($(this).text());
		});
		if (headerFields.length == 2) {
			$('#WSOD_OptionData .optionTableHeader')
			.empty()
			.prepend('<h5 class="customH">' + headerFields[0] + ' Expiring on ' + headerFields[1] + '</h5>');
		}
		
		wsod.preLoadHovers();
	};

	wsod_Warrants_page = function(pagingOptions) {

		wsod_Warrants.PageRequest(pagingOptions);
	};

    wsod_Warrants.PageRequest = function(pagingOptions) {

		$.extend(this.PageOptions, pagingOptions);
		var startIndex = pagingOptions.StartIndex == 1 ? 0 : pagingOptions.StartIndex;
		var oldStartIndex = this.PageOptions.FirstRow == 1 ? 0 : this.PageOptions.FirstRow;
		this.PageOptions.FirstRow = pagingOptions.StartIndex;

		wsod.showAjaxLoader($('#WSOD_OptionData').find('tbody'));
		var self = this;
		setTimeout(function() {

			for (var i = 0; i < 20 && oldStartIndex + i < self.data.length; i++) {
				wsod.hide($(self.data[oldStartIndex + i]));
			}

			for (var i = 0; i < 20 && startIndex + i < self.data.length; i++) {
				wsod.show($(self.data[startIndex + i]));
			}

			wsod.hideAjaxLoader($('#WSOD_OptionData').find('tbody'));

		}, 1);
	};

    wsod_Warrants.filter = function() {
    

		if (wsod_Warrants.filters.length == 0)
			return;

		// load warrants
		wsod.showAjaxLoader($('#WSOD_OptionData').find('tbody'));

		wsod.load({
			issueID: $('#wsod_mainissueID').val()
			, issueType: wsod_Warrants.filters[0].val()
			, symbolID: $('#wsod_mainsymbol').val()
			, optionType: 'callput'
			, expiry: wsod_Warrants.filters[1].val()
			, partial: wsod_Warrants.issueType == wsod_Warrants.filters[0].val() ? 1 : 0
		}
		, "Api/getWarrants"
		, wsod_Warrants.update
		, function(xhr, status, err) {
			wsod.hideAjaxLoader($('#WSOD_OptionData').find('tbody'));
		}
		, null
		, null
		
		
	);

		wsod_Warrants.issueType = wsod_Warrants.filters[0].val();
	};

	wsod_Warrants.init = function() {

		$('#WSOD_OptionNav select').each(function() {

			var select = $(this).selectmenu({ style: 'dropdown', change: wsod_Warrants.filter, root: wsod.getRoot() });
			wsod_Warrants.filters.push(select);


			if (select.attr('id') == 'wsod_selWarrantType')
				wsod_Warrants.issueType = select.val();
		});

		//-- mac firefox (selectmenu width not being applied) --//
		$('div.wsod ul.wsod_selWarrantType').width(typeWidth);
		$('#WSOD_OptionNav .wsod_selWarrantType').next().width(typeWidth);
		$('div.wsod ul.wsod_selOptionDate').width(dateWidth);
		$('#WSOD_OptionNav .wsod_selOptionDate').next().width(dateWidth);
		//-- mac firefox --//

		this.data = $('#WSOD_OptionData').find('tbody tr');
		for (var i = 20; i < this.data.length; i++) {
			wsod.hide($(this.data[i]));
		}
	};

})(jQuery);

var wsod_Options = {};

(function($) {

	var typeWidth = 102;
	var dateWidth = 136;
	var displayWidth = 136;

	wsod_Options.callputSelect = null;
	wsod_Options.expirySelect = null;
	wsod_Options.displaySelect = null;
	wsod_Options.optionType = '';
	wsod_Options.strike = '';
	wsod_Options.issueType = '';
	wsod_Options.PageOptions = {
		"RowCount": 20
	, "FirstRow": 1
	};
	wsod_Options.update = function(data, status, xhr) {

		var tbody = $('#WSOD_M_OptionView').find('tbody');
		wsod.hideAjaxLoader($('#WSOD_M_OptionView'));

		if (data.html) {
			$('#WSOD_M_OptionView').parent().html(data.html);
		}

		if (data.expirations) {

			$('#wsod_selOptionDate').parent().remove();
			$('#WSOD_OptionNav').append(data.expirations);
			var select = $('#wsod_selOptionDate').selectmenu({ style: 'dropdown', change: wsod_Options.filter, root: wsod.getRoot() });
			wsod_Options.expirySelect = select;

			//-- mac firefox (selectmenu width not being applied) --//
			$('div.wsod ul.wsod_selOptionDate').width(dateWidth);
			$('#WSOD_OptionNav .wsod_selOptionDate').next().width(dateWidth);
			//-- mac firefox --//
		}

		if (data.pagerOptions) {
			var pagerJSON = $.fromJSON(data.pagerOptions);
            $('#WSOD_M_OptionView .paging').pagination(pagerJSON);
			wsod_Options.data = $('#WSOD_M_OptionView').find('tbody tr');
			
			//need to reset PageOptions.FirstRow because wsod_Options.PageRequest() uses FirstRow for pagination
			wsod_Options.PageOptions.FirstRow = pagerJSON.StartIndex;
	
			for (var i = 20; i < wsod_Options.data.length; i++) {
				wsod.hide($(wsod_Options.data[i]));
			}
		}

		if (wsod_Options.data.length) {
			$(wsod_Options.data[Math.min(wsod_Options.data.length - 1, 19)]).addClass('last');
		}
		wsod.preLoadHovers();
	};

	wsod_Options_page = function(pagingOptions) {

		wsod_Options.PageRequest(pagingOptions);
	};

    wsod_Options.PageRequest = function(pagingOptions) {

		$.extend(this.PageOptions, pagingOptions);
		var startIndex = pagingOptions.StartIndex == 1 ? 0 : pagingOptions.StartIndex;
		var oldStartIndex = this.PageOptions.FirstRow == 1 ? 0 : this.PageOptions.FirstRow;
		this.PageOptions.FirstRow = pagingOptions.StartIndex;

		wsod.showAjaxLoader($('#WSOD_M_OptionView'));
		var self = this;
		setTimeout(function() {

			var i;
			for (i = 0; i < 20 && oldStartIndex + i < self.data.length; i++) {
				wsod.hide($(self.data[oldStartIndex + i]));
			}
			$(self.data[oldStartIndex + (i - 1)]).removeClass('last');

			for (i = 0; i < 20 && startIndex + i < self.data.length; i++) {
				wsod.show($(self.data[startIndex + i]));
			}
			$(self.data[startIndex + (i - 1)]).addClass('last');
			wsod.hideAjaxLoader($('#WSOD_M_OptionView'));

		}, 1);
	};

    wsod_Options.filterByExpiry = function(date) {

		wsod_Options.expirySelect.val(date);
		wsod_Options.strike = '';
		wsod_Options.filter();


	};

    wsod_Options.filterByStrike = function(strike) {

		try {
			wsod_Options.strike = strike;
		} catch (e) {
			wsod_Options.strike = '';
		}
		wsod_Options.filter();

	};

    wsod_Options.filter = function() {

		// load options
		wsod.showAjaxLoader($('#WSOD_M_OptionView'), "b");

		wsod.load(
			{
				issueID: $('#wsod_mainissueID').val()
				, optionType: wsod_Options.callputSelect.val()
				, last: $('#wsod_lastprice').val().replace('$', '')
				, display: wsod_Options.displaySelect.val()
				, expiry: wsod_Options.expirySelect.val()
				, partial: wsod_Options.optionType == wsod_Options.callputSelect.val() ? 1 : 0
				, strike: wsod_Options.strike
				, issueType: wsod_Options.issueType
			}
			, "Api/getOptions"
			, wsod_Options.update
			, function(xhr, status, err) {
				wsod.hideAjaxLoader($('#WSOD_M_OptionView'));
			}
			, null
			, null
			, false
	);

		wsod_Options.optionType = wsod_Options.callputSelect.val();
		var colName = $("#WSOD_OptionTableData th.col-exPrice").text();

		if(colName == "Expiry Date") //check if the 7th column (col-exPrice) contains currencies or dates - hacky way, but seems to be the only way with our specific case/using tablesorter for this
		{
			$('#WSOD_OptionTableData').tablesorter({ 	
				headers:{6: {sorter: 'shortDate'}} //sort the 7th column/date column (0 based index) to use shortDate sorting when it contains dates
			});
		}
		else
		{
			$('#WSOD_OptionTableData').tablesorter(); //just run normal currency sorting for the 7th col when it contains exercise prices
		}	
	};

	wsod_Options.init = function() {

		wsod_Options.callputSelect = $('#wsod_selOptionType').selectmenu(
			{ style: 'dropdown', change: wsod_Options.filter, root: wsod.getRoot() });
		wsod_Options.expirySelect = $('#wsod_selOptionDate').selectmenu(
			{ style: 'dropdown', change: function() { wsod_Options.strike = ''; wsod_Options.filter(); }, root: wsod.getRoot() });
		wsod_Options.displaySelect = $('#wsod_selOptionDisplay').selectmenu(
			{ style: 'dropdown', change: wsod_Options.filter, root: wsod.getRoot() });

		//console.log(typeWidth);

		//-- mac firefox (selectmenu width not being applied) --//
		$('div.wsod ul.wsod_selOptionType').width(typeWidth);
		$('#WSOD_OptionNav .wsod_selOptionType').next().width(typeWidth);
		$('div.wsod ul.wsod_selOptionDate').width(dateWidth);
		$('#WSOD_OptionNav .wsod_selOptionDate').next().width(dateWidth);
		$('div.wsod ul.wsod_selOptionDisplay').width(displayWidth);
		$('#WSOD_OptionNav .wsod_selOptionDisplay').next().width(displayWidth);
		//-- mac firefox --//

		wsod_Options.optionType = wsod_Options.callputSelect.val();
		this.data = $('#WSOD_OptionTableData').find('tbody tr');
	};

	wsod_Options.initChart = function(jsonInput) {
		if(typeof $('#wsod_SelPayoffStrategy').selectmenu == 'function') {
			$('#wsod_SelPayoffStrategy').selectmenu({ style: 'dropdown', change: function() {

				// load options
				wsod.showAjaxLoader($('#WSOD_P_OptionExecution div.chartModule'));
				var transType = $(this).val();
				var optionID = $("#wsod_mainissueID").val();

				wsod.load({
					OptionID: optionID,
					TransType: transType
				}
				, "Api/OptionChart"
				, function(data, status, xhr) {

					wsod.hideAjaxLoader($('#WSOD_P_OptionExecution div.chartModule'));

					if (data.src) {
						$('#WSOD_P_OptionExecution div.chartModule .content img').attr('src', data.src);
					}
				}
				, function(xhr, status, err) {
					wsod.hideAjaxLoader($('#WSOD_P_OptionExecution div.chartModule'));
				}
				, null
				, null
			);

			}, root: wsod.getRoot()
			});
		}
	};
})(jQuery);